import { ProductInventoryComponent } from './partials/product-inventory/product-inventory.component';
import { ProductPricingV2Component } from './partials/product-pricing-v2/product-pricing-v2.component';
import { GlobalService } from 'src/app/_services/global.service';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { VendorsService } from 'src/app/_services/vendors.service';
import { ManufacturersService } from 'src/app/_services/manufacturers.service';
import { CategoryService } from 'src/app/_services/category.service';
import { ProductsService } from 'src/app/_services/products.service';
import { ReportsService } from 'src/app/_services/reports.service';
import { ChangeDetectorRef, Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductDetailsComponent } from './partials/product-details/product-details.component';

import { DepartmentService } from 'src/app/_services/department.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { BarcodeLabelPrintingService } from 'src/app/_services/barcode-label-printing.service';

@Component({
  selector: 'app-create-product-v2',
  templateUrl: './create-product-v2.component.html',
  styleUrls: ['./create-product-v2.component.scss']
})
export class CreateProductV2Component implements OnInit, AfterViewInit {
  activeStateB: boolean[] = [true, true, true, true];
  inventorySectionError = false;
  additionalDetailsError = false;
  editform!: FormGroup
  // Label Printing 
  labelForm: FormGroup
  selectedTemplate: any = null;
  dummyImageData = "https://preview.keenthemes.com/metronic8/demo2/assets/media/svg/files/blank-image.svg";

  fileToUpload: any;

  isNew = true
  tobesaved = false
  saveMenuItems: MenuItem[] = [
    {
      label: 'Save',
      icon: 'pi pi-check',
      command: () => this.saveProductClick('save-only'),
    },
    {
      label: 'Cancel',
      icon: 'pi pi-times',
      command: () => this.cancelClick(),
    },
    {
      label: 'Save as Duplicate',
      icon: 'pi pi-copy',
      command: () => this.saveProductClick('save-and-duplicate'),
    },
  ];
  sellChipOptions = [
    { label: 'Online', value: 'online', id: 1 },
    { label: 'In-store', value: 'offline', id: 2 },
  ];
  selectedSellChips: string[] = [];
  get saveMenuItemsStateful(): MenuItem[] {
    // Leave items clickable; saveProductClick guards validity internally.
    return this.saveMenuItems;
  }

  items: MenuItem[] = [
    { label: 'General', icon: 'pi pi-fw pi-home' },
    { label: 'Product Images', icon: 'pi pi-fw pi-file' },
    { label: 'Stock Management', icon: 'pi pi-fw pi-calendar' },
    { label: 'Shipping', icon: 'pi pi-fw pi-plus-circle' },
    { label: 'Additional', icon: 'pi pi-fw pi-plus-circle' },
    { label: 'Print Label', icon: 'pi pi-fw pi-print', visible: this.isNew },
  ]

  activeItem: any = { label: 'General', icon: 'pi pi-fw pi-home' }
  thFiles: any = ''
  isFreeTrialPlan = false

  @ViewChild('fileInput') fileInput: FileUpload;
  @ViewChild(ProductDetailsComponent) __productDetail!: ProductDetailsComponent
  @ViewChild(ProductPricingV2Component) __productPricing!: ProductPricingV2Component
  @ViewChild(ProductInventoryComponent) __productInventory!: ProductInventoryComponent
  _globals = GlobalService

  tagsForm: FormGroup;
  alreadyExistBarcodes: any;

  tempImageUrl = ""
  tempItemImage: any;
  // activeTemplateId = 1;
  templateList: any[] = [
    { templateId: 1, templateName: 'QR Code - with Business Name', templateURL: 'assets/images/qr_code_with_business_name.png' },
    { templateId: 2, templateName: 'QR Code - without Business Name', templateURL: 'assets/images/qr_code_without_business_name.png' },
    { templateId: 3, templateName: 'Barcode - with Logo', templateURL: 'assets/images/barcode_with_logo.png' },
    { templateId: 4, templateName: 'Barcode - without Logo', templateURL: 'assets/images/barcode_without_logo.png' },
    { templateId: 5, templateName: 'Barcode - complete Details', templateURL: 'assets/images/barcode_with_compete_details.png' },
  ]
  selectedBrand: any = null;
  selectedlabelSizes: any = null;
  selectedlabelStyle: any = null
  configuration: any = [];

  constructor(
    public _reportService: ReportsService,
    public _catService: CategoryService,
    public _manufacturers: ManufacturersService,
    public _vendors: VendorsService,
    public _productService: ProductsService,
    public _abd: AppBaseDataService,
    private _connMessageService: ConnMessageService,
    private _spinner: NgxSpinnerService,
    private _fb: FormBuilder,
    public _departmentService: DepartmentService,
    private _router: Router,
    private _route: ActivatedRoute,
    public _platform: Platform,
    public _barcodeLabelServices: BarcodeLabelPrintingService,
    private _confirmationService: ConfirmationService,
    private cd: ChangeDetectorRef
  ) { }
  selectedProductSellType = { Type: "All", id: 3, show: true }
  ngOnInit(): void {
    if (this._abd.shouldUseLegacyProductsForCurrentUser()) {
      this._router.navigateByUrl('/app/new-product', { replaceUrl: true })
      return
    }

    if (!this._productService.activeItem) {
      // Default to new mode when no product is selected (direct navigation)
      this._productService.isNew = true
      this._productService.isEdit = false
      this._productService.isViewOnly = false
      this._productService.featureImage = null
      this._productService.thImages = []
      this._productService.thImageNames = []
    }

    this._abd.resetAllBehaviorSubjects()
    this.isFreeTrialPlan = !!this._globals.userInfo?.businessSetup?.[0]?.isFreeTrial
    // this.activeTemplate(1)
    // try {
    //   const abd = this._abd
    //   if (abd.departments.length < 1 || abd.categories.length < 1 || abd.manufacturers.length < 1 || abd.vendors.length < 1) {
    //     this._connMessageService.showToastMessage('No department(s)/category(s)/manufacturer(s) or vendor(s) not available!', 'error');
    //     window.history.back()
    //   }
    // } catch {
    //   this._connMessageService.showToastMessage('No department(s)/category(s)/manufacturer(s) or vendor(s) not available!', 'error');
    //   window.history.back()
    // }
    this.initForm()
    // this.getLabelPrinterConfiguration()
    this.labelForm.valueChanges.subscribe((v) => {
      this.labelForm.markAllAsTouched()
      this.labelForm.markAsDirty()
    })
    if (this._productService.activeItem) {
      this.items = [
        { label: 'General', icon: 'pi pi-fw pi-home' },
        { label: 'Product Images', icon: 'pi pi-fw pi-file' },
        { label: 'Stock Management', icon: 'pi pi-fw pi-calendar' },
        { label: 'Shipping', icon: 'pi pi-fw pi-plus-circle' },
        { label: 'Additional', icon: 'pi pi-fw pi-plus-circle' },
        // { label: 'Print Label', icon: 'pi pi-fw pi-print',visible:this.isNew},
      ]
      this.prepareEditItem()
    }
    else {
      // const actloc = this._abd.initActLocations()
      // if (!actloc || actloc.length < 1) {
      //   this._connMessageService.showToastMessage('No active location available.', 'error');
      //   window.history.back()
      // }

      this.restAllFields()
      this.prepareNewItem()
    }
    this.refreshUomData()
    this.syncSellChipSelection();

    if (!this._abd.uom?.length) {
      this._abd.loadInit().subscribe(res => {
        if (res.success) {
          if (!this._productService.activeItem) {
            this.getInitData()
          }
          this.refreshUomData()
        }
      })
    }
  }


  getLabelPrinterConfiguration() {
    try {
      this._barcodeLabelServices.getbarcodeLabelConfiguration().subscribe(res => {
        if (res.success) {
          this.configuration = res.data
          this.configuration = this.configuration.map((val) => {
            return {
              brandName: val?.brand + ' (' + val?.model + ')',
              brand: val?.brand,
              model: val?.model,
              image: val?.image,
              labelSizes: val?.labelFormats.map((x) => {
                return {
                  name: x?.name,
                  style: x?.styles.map((s) => {
                    return {
                      name: s?.label,
                      image: s?.image
                    }
                  })
                }
              })
            }

          })

        }
      })
    } catch {
      this._connMessageService.showToastMessage('Label printing configuration fail to load', 'error');

    }
  }


  ngOnDestroy() {
    this.restAllFields()
    this._productService.resetVariables()
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
    this.removeNoBannerClass();
    this.updateAdditionalDetailsError();
    this.subscribeToSectionValidity();
    //console.log(`ngAfterViewInit - jokeViewChild is ${this.__productInventory}`)
  }

  whereToSellChanged() {
    this.updateSellFlagsFromChips();
  }

  async prepareEditItem() {
    this.isNew = false
    const item = this._productService.activeItem
    const primarySku = this.getPrimarySku(item)
    const shipping = primarySku?.shippingDimention ?? {}
    //console.log('<< EDIT-ITEM >>', this._productService.activeItem)

    // Reset images so edits start from the current product state only
    this.populateImagesFromActiveItem(item);

    this._productService.isReturnable = item.isReturnable
    this._productService.pts.t_productName = item.itemName
    this._productService.pts.descriptionUrl = item.descriptionURL
    this._productService.isPrintAsQR = item.printAsQRCodeOnReceipt
    this._productService.productDescription = item.description

    let temp: any = ''
    temp = this._productService.productInfo.itemType.find(f => f.value === item.itemType)
    this._productService.selectedProductType = temp

    temp = this._productService.productInfo.sellAs.find(f => f.value === item.soldAs)
    this._productService.selectedSellAs = temp

    temp = this._productService.productInfo.grouping.find(f => f.value === item.grouping)
    this._productService.selectedGrouping = temp

    temp = this._productService.productInfo.discount.find(f => f.value === item.allowDiscount)
    this._productService.selectedDiscount = temp

    temp = this._productService.productInfo.ageRestriction.find(f => f.value === item.ageRestriction)
    this._productService.selectedAgeRestriction = temp

    temp = this._productService.productInfo.gender.find(f => f.value === item.gender)
    this._productService.selectedGender = temp
    //-- inventory
    this._productService.pts.sku = primarySku?.skuCode ?? ''
    this._productService.pts.barcode = primarySku?.barcode ?? ''
    // -- Secondary SKU & Barcode
    // --BST--
    this._productService.pts.altBarcode = primarySku?.barcodes ?? []
    this._productService.pts.altSKUs = primarySku?.skus ?? []
    this._productService.pts.altTags = primarySku?.tags ?? []
    // --BST--
    this._productService.isTrackStock = item.trackStock
    this._productService.isAllowNegativeStock = item.allowNegativeStock
    this._productService.isSellOnline = item.sellOnline

    // item.sellOnline == true ? this._abd.selectedProductSellType = this._abd.productSellType[0] : this._abd.selectedProductSellType = this._abd.productSellType[1]
    item.sellOnline == true ? this._abd.selectedProductSellType = this._abd.productSellType[0] : this._abd.selectedProductSellType = this._abd.productSellType[1]
    // Auto PO
    this._productService.pts.autoPurchaseOrder = primarySku?.autoPurchaseOrder ?? false
    //  Auto PO
    //-- pricing
    this._productService.pts.priceA = primarySku?.salePriceA ?? 0
    this._productService.pts.priceB = primarySku?.salePriceB ?? 0
    this._productService.pts.priceC = primarySku?.salePriceC ?? 0
    this._productService.pts.minLevel = primarySku?.minLevel ?? 0
    this._productService.pts.maxLevel = primarySku?.maxLevel ?? 0
    this._productService.pts.minOrderQty = primarySku?.minOrderQty ?? 0
    // Auto PO
    this._productService.pts.maxOrderQty = primarySku?.maxOrderQty ?? 0
    // Auto PO
    this._productService.pts.reorderLevel = primarySku?.reorderLevel ?? 0

    this._productService.pts.costPrice = primarySku?.costPrice ?? 0
    this._productService.pts.discountPrice = primarySku?.discountPrice ?? 0

    temp = this._productService.productInfo.defaultPrice.find(f => f.value === primarySku?.defaultPrice)
    this._productService.selectedDefaultPrice = temp

    this._productService.isTaxable = item.isTaxable
    this._productService.isOpenPrice = item.isOpnDept // ??

    temp = this._productService.productInfo.taxRate.find(f => f.value === primarySku?.taxRateId)
    // this._productService.selectedDefaultPrice = temp

    if (temp) {
      let s = JSON.parse(JSON.stringify(temp))
      s.name = s.name.replace(/\s\d+$/, '');
      const percentage = this._abd.systemConfigs.taxConfig.tax1;
      s.name = `${s.name} (${percentage}%)`;
      this._productService.taxRates = [s];
      this._productService.selectedTaxRate = s;
    }

    temp = this._productService.productInfo.sellQuantity.find(f => f.value === primarySku?.sellQuantity)
    this._productService.selectedSellQuantity = temp

    temp = this._abd.uom.find(f => f.id === primarySku?.uomId)
    this._abd.selectedUom = temp
    this._productService.pts.caseQty = primarySku?.caseQty ?? 0

    //-- product notes
    this._productService.productNotes = item.notes
    this._productService.printNotesOnReceipt = item.printOnInvoice
    this._productService.ShowNotesWhenRingingItem = item.showNotesWhen

    //-- general
    this._abd.selectedDepartment = this._abd.initActDepartments().filter(f => f.id === item.departmentId)[0]
    this._abd.selectedCategory = this._abd.initActCategories().filter(f => f.id === item.categoryId)[0]
    this._abd.selectedManufacturer = this._abd.initActManufacturers().filter(f => f.id === item.manufacturerId)[0]
    this._abd.selectedVendor = this._abd.initActVendors().filter(f => f.id === item.vendorId)[0]

    //----- shipping information
    temp = this._abd.WeightUOM.find(f => f.id == shipping?.weightUOM)
    this._productService.selectedShippingWeight = temp
    this._productService.shippingWeight = shipping?.weight ?? 0

    temp = this._abd.DimensionUOM.find(f => f.id == shipping?.dimensionUOM)
    this._productService.selectedShippingDimension = temp
    this._productService.shippingHeight = shipping?.height ?? 0
    this._productService.shippingWidth = shipping?.width ?? 0
    this._productService.shippingLength = shipping?.length ?? 0

    //----- shipping information
    if (item.productSellType == 'online') this._abd.selectedProductSellType = this._abd.productSellType[0]
    if (item.productSellType == 'offline') this._abd.selectedProductSellType = this._abd.productSellType[1]
    if (item.productSellType == 'all') this._abd.selectedProductSellType = this._abd.productSellType[2]

    // this._globals.sleep(1000).then(() => {
    //   // const eee = this.getBase64Image(document.getElementById("imageid"), item.image)
    // })
    setTimeout(() => {
      this.updatemetaDetails();
    }, 500);
  }

  private getPrimarySku(item: any): any {
    const list = item?.crsItemSKUs ?? item?.itemSKUs ?? item?.ItemSKUs ?? []
    if (!Array.isArray(list) || !list.length) return null
    return list[0]
  }

  private toOpeningStockNumber(value: any): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private getOpeningStockKey(locationId: any, skuCode: any): string {
    const locationKey = String(locationId ?? '').trim().toLowerCase();
    const skuKey = String(skuCode ?? '').trim().toLowerCase();
    if (!locationKey || !skuKey) {
      return '';
    }
    return `${locationKey}|${skuKey}`;
  }

  private buildOpeningStockChangePayload(openingStocks: any[]): any[] {
    const nextStocks = Array.isArray(openingStocks) ? openingStocks : [];
    const timestamp = new Date().toISOString();

    if (this._productService.isNew) {
      return nextStocks.map((stock) => ({
        ...stock,
        IsChanged: true,
        isChanged: true,
        changeType: 'added',
        updateTime: timestamp,
        updatedAt: timestamp
      }));
    }

    const previousRaw =
      this._productService.activeItem?.OpeningStocks
      ?? this._productService.activeItem?.openingStocks
      ?? [];
    const previousStocks = Array.isArray(previousRaw) ? previousRaw : [];
    const previousByKey = new Map<string, any>();

    previousStocks.forEach((stock) => {
      const key = this.getOpeningStockKey(
        stock?.locationId ?? stock?.LocationId,
        stock?.skuCode ?? stock?.SkuCode
      );
      if (key) {
        previousByKey.set(key, stock);
      }
    });

    const processedKeys = new Set<string>();
    const payload: any[] = [];

    nextStocks.forEach((stock) => {
      const key = this.getOpeningStockKey(stock?.locationId, stock?.skuCode);
      const previous = key ? previousByKey.get(key) : null;
      const previousQty = this.toOpeningStockNumber(previous?.quantity ?? previous?.Quantity);
      const nextQty = this.toOpeningStockNumber(stock?.quantity ?? stock?.Quantity);
      const isAdded = !previous;
      const isUpdated = !!previous && previousQty !== nextQty;
      const isChanged = isAdded || isUpdated;
      const existingUpdateTime =
        stock?.updateTime
        ?? stock?.updatedAt
        ?? previous?.updateTime
        ?? previous?.updatedAt
        ?? null;

      payload.push({
        ...stock,
        IsChanged: isChanged,
        isChanged: isChanged,
        changeType: isAdded ? 'added' : (isUpdated ? 'updated' : 'unchanged'),
        previousQuantity: previousQty,
        updateTime: isChanged ? timestamp : existingUpdateTime,
        updatedAt: isChanged ? timestamp : existingUpdateTime
      });

      if (key) {
        processedKeys.add(key);
      }
    });

    previousByKey.forEach((previous, key) => {
      if (processedKeys.has(key)) {
        return;
      }

      payload.push({
        ...previous,
        locationId: previous?.locationId ?? previous?.LocationId,
        skuCode: previous?.skuCode ?? previous?.SkuCode,
        quantity: 0,
        price: previous?.price ?? previous?.Price ?? 0,
        IsChanged: true,
        isChanged: true,
        isRemoved: true,
        removed: true,
        isDeleted: true,
        changeType: 'removed',
        previousQuantity: this.toOpeningStockNumber(previous?.quantity ?? previous?.Quantity),
        updateTime: timestamp,
        updatedAt: timestamp
      });
    });

    return payload;
  }

  getBase64Image(img, url) {
    var image = new Image()
    image.setAttribute('crossorigin', 'anonymous');
    image.src = url
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0);
    var dataURL = canvas.toDataURL("image/jpg");
    return dataURL.replace(/^data:image\/(png|jpg|jpeg|pdf|webp);base64,/, "");
  }

  restAllFields() {
    this._productService.activeItem = null

    const productInfo = this._productService.productInfo || {};
    const defaultPrice = productInfo.defaultPrice?.[0] ?? null;
    const taxRateBase = productInfo.taxRate?.[0] ?? null;
    const sellQuantity = productInfo.sellQuantity?.[0] ?? null;

    this.tempImageUrl = ''
    this._productService.featureImage = null
    this._productService.thImages = []
    this._productService.thImageNames = []
    this._productService.pts.t_productName = ''
    this._productService.isPrintAsQR = false
    this._productService.productDescription = ''

    this._productService.selectedLocations = []

    this._productService.selectedProductType = productInfo.itemType?.[0] ?? null
    this._productService.selectedSellAs = productInfo.sellAs?.[1] ?? productInfo.sellAs?.[0] ?? null
    this._productService.selectedGrouping = productInfo.grouping?.[0] ?? null
    this._productService.selectedDiscount = productInfo.discount?.[0] ?? null
    this._productService.selectedAgeRestriction = productInfo.ageRestriction?.[0] ?? null
    this._productService.selectedGender = productInfo.gender?.[0] ?? null
    //-- inventory
    this._productService.pts.sku = ''
    this._productService.pts.barcode = ''

    // --BST--
    this._productService.pts.itemSKUId = ""
    this._productService.pts.altBarcode = []
    this._productService.pts.altSKUs = []
    this._productService.pts.altTags = []

    // --BST--
    this._productService.isTrackStock = false
    this._productService.isAllowNegativeStock = false
    this._productService.isSellOnline = false

    //-- pricing
    this._productService.pts.priceA = ''
    this._productService.pts.priceB = ''
    this._productService.pts.priceC = ''

    this._productService.pts.costPrice = ''
    this._productService.pts.discountPrice = ''

    this._productService.selectedDefaultPrice = defaultPrice

    this._productService.isTaxable = false
    this._productService.isOpenPrice = false

    if (taxRateBase) {
      const s = { ...taxRateBase };
      const percentage = this._abd.systemConfigs?.taxConfig?.tax1;
      if (percentage !== undefined && percentage !== null) {
        s.name = `${s.name} (${percentage}%)`;
      }
      this._productService.taxRates = [s];
      this._productService.selectedTaxRate = s;
    } else {
      this._productService.taxRates = [];
      this._productService.selectedTaxRate = null;
    }

    this._productService.selectedSellQuantity = sellQuantity
    this._abd.selectedUom = this._abd.uom?.[0] ?? null
    this._productService.pts.caseQty = ''


    //-- product notes
    this._productService.productNotes = ''
    this._productService.printNotesOnReceipt = false
    this._productService.ShowNotesWhenRingingItem = false

    //-- general
    this.getInitData()

    //----- shipping information
    this._productService.selectedShippingWeight = ''
    this._productService.shippingWeight = 0

    this._productService.selectedShippingDimension = this._abd.DimensionUOM[3]
    this._productService.shippingHeight = 0
    this._productService.shippingWidth = 0
    this._productService.shippingLength = 0
  }

  prepareNewItem() {
    this._productService.isNew = true
    this._productService.isEdit = false
    this._productService.isViewOnly = false

    let sku: any = <any>this._globals.generateSKU() * 1
    this._productService.pts.sku = this._globals.generateSKU()
    this._productService.pts.barcode = this._globals.generateSKU()
    this._productService.pts.barcode = (sku + 23) + ''

    const defaultPrice = this._productService.productInfo?.defaultPrice?.[0] ?? null
    this._productService.selectedDefaultPrice = defaultPrice
    this._abd.selectedUom = this._abd.uom?.find?.(f => f.unitName === 'Each') ?? this._abd.uom?.[0] ?? null

    try {
      this._productService.productNotes = ''
      this.getInitData()
      this.activeItem = this.items[0]
      // this._productService.locations = JSON.parse(JSON.stringify(this._abd.actLocations))

      if (Array.isArray(this._productService.locations)) {
        for (let i = 0; i < this._productService.locations.length; i++)
          this._productService.locations[i].openingQty = 0

        this._productService.selectedLocations = []
        if (this._productService.locations[0]) {
          this._productService.selectedLocations.push(this._productService.locations[0])
        }
      }

      this._productService.pts.descriptionUrl = ''
      this._productService.labelPrintingImage = "";
    }
    catch {

      this._abd.loadInit().subscribe(res => {
        if (res.success) {
          this.getInitData()
          this.activeItem = this.items[0]
          this._productService.locations = JSON.parse(JSON.stringify(this._abd.locations))

          if (Array.isArray(this._productService.locations)) {
            for (let i = 0; i < this._productService.locations.length; i++)
              this._productService.locations[i].openingQty = 0

            this._productService.selectedLocations = []
            if (this._productService.locations[0]) {
              this._productService.selectedLocations.push(this._productService.locations[0])
            }
          }
        }
      })
    }
  }
  initForm() {
    this.labelForm = this._fb.group({
      location: ['', Validators.required],
      locations: ['', Validators.required],
      noOfCopy: ['', [Validators.required, Validators.maxLength(6), Validators.pattern(/^([0-9]\d*)(\.\d+)?$/)]],
    })
    this.tagsForm = this._fb.group({
      altBarcodes: [{ value: [], disabled: this._productService.isViewOnly }],
      altSKUs: [{ value: [], disabled: this._productService.isViewOnly }],
      altTags: [{ value: [], disabled: this._productService.isViewOnly }],
    })
    this.changeEvent()
  }
  updatemetaDetails() {
    this.tagsForm.get('altBarcodes')?.setValue(this._productService.pts?.altBarcode)
    this.tagsForm.get('altSKUs')?.setValue(this._productService.pts?.altSKUs)
    this.tagsForm.get('altTags')?.setValue(this._productService.pts?.altTags)
  }
  changeEvent() {
    this.tF.altBarcodes.valueChanges.subscribe((v) => {
      this.findDuplicates(this.tF.altBarcodes.value, this.tF.altBarcodes)
    })
    this.tF.altSKUs.valueChanges.subscribe((v) => {
      this.findDuplicates(this.tF.altSKUs.value, this.tF.altSKUs)
    })
    this.tF.altTags.valueChanges.subscribe((v) => {
      this.findDuplicates(this.tF.altTags.value, this.tF.altTags)
    })

  }
  findDuplicates(arr: any[], input) {
    const seen = new Set();
    const duplicates = new Set();

    for (const value of arr) {
      if (seen.has(value)) {
        duplicates.add(value);
      } else {
        seen.add(value);
      }
    }
    if (Array.from(duplicates).length > 0) {
      input?.setErrors({ duplicates: true });
      // this.alreadyExistBarcodes = Array.from(duplicates).join(', ')
    }
    // else{
    //   input?.setErrors(null);
    //   input?.updateValueAndValidity();;
    //   // this.alreadyExistBarcodes = ''
    // }
  }
  get f() {
    return this.labelForm.controls;
  }
  get tF() {
    return this.tagsForm.controls;
  }

  //   activeTemplate(id){
  //     this.activeTemplateId = id; 
  // }
  getInitData() {
    this._abd.selectedCategory = this._abd.initActDepartments()[0]
    this._abd.selectedCategory = this._abd.initActCategories()[0]
    this._abd.selectedManufacturer = this._abd.initActManufacturers()[0]
    this._abd.selectedVendor = this._abd.initActVendors()[0]
  }

  private refreshUomData(): void {
    if (!Array.isArray(this._abd.uom) || this._abd.uom.length === 0) return

    const sellAsValue =
      this._productService.selectedSellAs?.value ??
      this._productService.productInfo?.sellAs?.[0]?.value ??
      null

    let baseList: any[] = []
    if (sellAsValue !== null && sellAsValue !== undefined) {
      baseList = this._abd.uom.filter(f => f.unitClassId === sellAsValue)
    } else if (Array.isArray(this._abd.uomCalc) && this._abd.uomCalc.length) {
      baseList = [...this._abd.uomCalc]
    } else {
      baseList = [...this._abd.uom]
    }

    const allowedNames = new Set(['each', 'box'])
    const allowedList = baseList.filter(
      f => allowedNames.has(String(f?.unitName || '').toLowerCase())
    )
    this._abd.uomCalc = allowedList.length ? allowedList : baseList

    const selectedId = this._abd.selectedUom?.id
    const isSelectedValid =
      selectedId !== undefined &&
      selectedId !== null &&
      this._abd.uomCalc.some(f => f.id === selectedId)

    if (!isSelectedValid) {
      this._abd.selectedUom =
        this._abd.uomCalc.find(f => String(f?.unitName || '').toLowerCase() === 'each') ??
        this._abd.uomCalc.find(f => String(f?.unitName || '').toLowerCase() === 'box') ??
        this._abd.uomCalc[0] ??
        null
    }
  }

  onTabItemClick(tab: any) {
    // console.log()
    //   if(this.activeItem.label === 'Stock Management'){
    //     this._confirmationService.confirm({
    //       header: `Confirmation?`,
    //       message: `Changes you made will be lost. Are you sure you want to proceed?`,
    //       accept: () => {
    //     // Start 
    //       this.activeItem = tab.activeItem  
    //     // End
    //       }
    //     });
    //   }else{
    this.activeItem = tab.activeItem
    // }        
  }

  onInventoryTabClose(): void {
    const form = this.__productInventory?.editform;
    if (form && this.hasInventoryRequiredErrors(form)) {
      form.markAllAsTouched();
      this.inventorySectionError = true;
      this._connMessageService.showToastMessage('Inventory section has required fields. Please expand to fix them.', 'error');
    } else {
      this.inventorySectionError = false;
    }
    this.updateAdditionalDetailsError();
  }

  onInventoryTabOpen(): void {
    this.inventorySectionError = false;
    this.updateAdditionalDetailsError();
  }

  onPricingTabClose(): void {
    const form = this.__productPricing?.editform;
    if (form && form.invalid) {
      form.markAllAsTouched();
    }
    this.updateAdditionalDetailsError();
  }

  onPricingTabOpen(): void {
    this.updateAdditionalDetailsError();
  }

  onAdditionalDetailsClose(): void {
    this.updateAdditionalDetailsError();
  }

  onAdditionalDetailsOpen(): void {
    this.updateAdditionalDetailsError();
  }

  private updateAdditionalDetailsError(): void {
    const inventoryInvalid = this.hasInventoryRequiredErrors(this.__productInventory?.editform) || this.inventorySectionError;
    const pricingInvalid = this.hasPricingRequiredErrors(this.__productPricing?.editform);
    this.additionalDetailsError = !!(inventoryInvalid || pricingInvalid);
  }

  private subscribeToSectionValidity(): void {
    const inventoryForm = this.__productInventory?.editform;
    if (inventoryForm) {
      inventoryForm.statusChanges.subscribe(() => this.updateAdditionalDetailsError());
    }

    const pricingForm = this.__productPricing?.editform;
    if (pricingForm) {
      pricingForm.statusChanges.subscribe(() => this.updateAdditionalDetailsError());
    }
  }

  accordion_b_toggle(index: number) {
    this.activeStateB[index] = !this.activeStateB[index] ? false : true
  }

  get hasAdditionalDetailsError(): boolean {
    return this.additionalDetailsError;
  }

  private hasTouchedInvalid(control?: AbstractControl | null): boolean {
    return !!control && control.invalid && (control.dirty || control.touched);
  }

  private hasInventoryRequiredErrors(form?: FormGroup): boolean {
    if (!form) return false;
    return this.hasTouchedInvalid(form.get('sku')) || this.hasTouchedInvalid(form.get('barcode'));
  }

  private hasPricingRequiredErrors(form?: FormGroup): boolean {
    if (!form) return false;
    return this.hasTouchedInvalid(form.get('priceA')) || this.hasTouchedInvalid(form.get('costPrice'));
  }

  newDepartClick() {
    this._departmentService.activeItem.departmentName = ''
    this._productService.isNewDepartment = true
  }

  addCategory(): void {
    this._productService.isNewCategory = true;
  }

  departmentChanged(e) {
    this._abd.actCategories = this._abd.categories.filter(
      f => f.departmentId === e.value.id
    )

    if (this._abd.actCategories.length > 0)
      this._abd.selectedCategory = this._abd.actCategories[0]
    else
      this._abd.selectedCategory = null
  }

  onSellChipsChange(values: string[]): void {
    this.selectedSellChips = values;
    this.updateSellFlagsFromChips();
  }

  get isSaveDisabled(): boolean {
    return this._productService.isViewOnly || !this.validToSave();
  }

  onQuickPriceChange(value: string | number): void {
    const normalized = this.formatToTwoDecimals(value);
    this._productService.pts.priceA = normalized;
    const priceControl = this.__productPricing?.editform?.get('priceA');
    if (priceControl) {
      priceControl.setValue(normalized);
    }
  }

  onQuickPriceBlur(): void {
    const current = this._productService.pts.priceA;
    if (current === '' || current === null || current === undefined) {
      const normalized = this.formatToTwoDecimals(0);
      this._productService.pts.priceA = normalized;
      const priceControl = this.__productPricing?.editform?.get('priceA');
      if (priceControl) {
        priceControl.setValue(normalized);
      }
    }
  }

  onQuickCostChange(value: string | number): void {
    const normalized = this.formatToTwoDecimals(value);
    this._productService.pts.costPrice = normalized;
    const costControl = this.__productPricing?.editform?.get('costPrice');
    if (costControl) {
      costControl.setValue(normalized);
    }
  }

  onQuickCostBlur(): void {
    const current = this._productService.pts.costPrice;
    if (current === '' || current === null || current === undefined) {
      const normalized = this.formatToTwoDecimals(0);
      this._productService.pts.costPrice = normalized;
      const costControl = this.__productPricing?.editform?.get('costPrice');
      if (costControl) {
        costControl.setValue(normalized);
      }
    }
  }

  onZeroValueFocus(controlName: 'priceA' | 'costPrice', event: FocusEvent): void {
    const input = event?.target as HTMLInputElement | null;
    if (!input) return;
    const rawValue = (input.value || '').trim();
    if (!this.isZeroDisplayValue(rawValue)) return;
    if (this._productService?.pts && controlName in this._productService.pts) {
      this._productService.pts[controlName] = null;
    }
    const control = this.__productPricing?.editform?.get(controlName);
    if (control) {
      control.setValue(null);
    }
    setTimeout(() => {
      try {
        input.setSelectionRange(0, 0);
      } catch {}
    }, 0);
  }

  private isZeroDisplayValue(value: string): boolean {
    const normalized = value.replace(/[^0-9.-]/g, '');
    if (!normalized) return false;
    const numericValue = Number(normalized);
    return !isNaN(numericValue) && numericValue === 0;
  }

  onCategoryChanged(event: any): void {
    this._abd.selectedCategory = event?.value || event;
  }

  private syncSellChipSelection(): void {
    if (this.isFreeTrialPlan) {
      this.applyFreeTrialSellRules();
      return;
    }

    const sellType = this._abd.selectedProductSellType?.id;

    if (sellType === 3) {
      this.selectedSellChips = this.sellChipOptions.map((o) => o.value);
    } else if (sellType === 1) {
      this.selectedSellChips = ['online'];
    } else if (sellType === 2) {
      this.selectedSellChips = ['offline'];
    } else {
      this.selectedSellChips = this.sellChipOptions.map((o) => o.value);
    }

    this.updateSellFlagsFromChips(false);
  }

  private updateSellFlagsFromChips(resetSelection = true): void {
    if (this.isFreeTrialPlan) {
      this.applyFreeTrialSellRules();
      return;
    }

    const hasOnline = this.selectedSellChips.includes('online');
    const hasInStore = this.selectedSellChips.includes('offline');

    if (hasOnline && hasInStore) {
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 3) || this._abd.productSellType[0];
    } else if (hasOnline) {
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 1) || this._abd.productSellType[0];
    } else if (hasInStore) {
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 2) || this._abd.productSellType[1];
    } else if (resetSelection) {
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 3) || this._abd.productSellType[0];
      this.selectedSellChips = this.sellChipOptions.map((o) => o.value);
    }

    this._productService.isSellOnline = this._abd.selectedProductSellType.id === 1 || this._abd.selectedProductSellType.id === 3;
    if (this._productService.isSellOnline) {
      this._productService.isOpenPrice = false;
    }
  }

  private applyFreeTrialSellRules(): void {
    this.sellChipOptions = this.sellChipOptions.filter((o) => o.value === 'online');
    this.selectedSellChips = ['online'];
    this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 1) || this._abd.productSellType[0];
    this._productService.isSellOnline = true;
    this._productService.isOpenPrice = false;
  }

  private formatToTwoDecimals(value: string | number): number | '' {
    if (value === null || value === undefined || value === '') return '';
    const num = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(num)) return '';
    return parseFloat(num.toFixed(2));
  }

  private removeNoBannerClass(): void {
    const container = document.querySelector('.layout-main');
    container?.classList.remove('mt-4');
  }

  private populateImagesFromActiveItem(item: any): void {
    this._productService.featureImage = null;
    this._productService.featureImageIndex = null;
    this._productService.thImages = [];
    this._productService.thImageNames = [];
    this._productService.hasGalleryChanged = false;

    const itemPictures = Array.isArray(item?.itemPictures)
      ? item.itemPictures
      : Array.isArray(item?.ItemPictures)
        ? item.ItemPictures
        : [];

    // Preserve gallery pictures
    itemPictures.forEach((pic: any) => {
      const picture = String(pic?.picture ?? pic?.Picture ?? '').trim();
      if (picture) {
        this._productService.thImages.push(picture);
        this._productService.thImageNames.push(''); // placeholder to keep indexes aligned
      }
    });

    if (!this._productService.thImages.length) {
      const fallbackImages = [
        String(item?.image ?? item?.Image ?? '').trim(),
        String(item?.imageThumbnail ?? item?.ImageThumbnail ?? '').trim()
      ].filter((value, index, arr) => !!value && arr.indexOf(value) === index);

      fallbackImages.forEach((image) => {
        this._productService.thImages.push(image);
        this._productService.thImageNames.push('');
      });
    }

    const flaggedEntry = itemPictures.find((p: any) => p?.isFeature || p?.IsFeature || p?.isDefault || p?.IsDefault);
    const flagged = String(flaggedEntry?.picture ?? flaggedEntry?.Picture ?? '').trim();
    let flaggedIndex = flagged ? this._productService.thImages.indexOf(flagged) : -1;
    if (flaggedIndex === -1 && this._productService.thImages.length) {
      flaggedIndex = 0;
    }

    if (flaggedIndex >= 0) {
      this._productService.featureImageIndex = flaggedIndex;
      this._productService.featureImage = this._productService.thImages[flaggedIndex];
    }
  }

  async saveProductClick(where2: any) {
    if (!this.validToSave()) return

    this.makeSaveObject(where2)
    // if (where2 == 'save-only')
    //   window.history.back()
    // else {
    if (where2 === 'save-and-duplicate') {
      this._productService.pts.sku = this._globals.generateSKU()
      this._productService.pts.barcode = this._globals.generateSKU()
      this._productService.pts.barcode = ((<any>(this._productService.pts.barcode) * 1) + 23) + ''

      this.__productInventory.editform.controls['sku'].setValue(this._productService.pts.sku)
      this.__productInventory.editform.controls['barcode'].setValue(this._productService.pts.barcode)
      this.__productInventory.editform.controls['maxLevel'].setValue(this._productService.pts.maxLevel)
      this.__productInventory.editform.controls['minLevel'].setValue(this._productService.pts.minLevel)
      this.__productInventory.editform.controls['reorderLevel'].setValue(this._productService.pts.reorderLevel)
      this.__productInventory.editform.controls['minOrderQty'].setValue(this._productService.pts.minOrderQty)
      // Auto PO
      this.__productInventory.editform.controls['maxOrderQty'].setValue(this._productService.pts.maxOrderQty)

      this.isNew = true
    }
    // }
    // }
  }

  makeSaveObject(where2: any) {
    try {
      const abd = this._abd
      const xLimit = 1
      if (abd.departments.length < xLimit || abd.categories.length < xLimit || abd.manufacturers.length < xLimit || abd.vendors.length < xLimit) {
        this._connMessageService.showToastMessage('No department(s)/category(s)/manufacturer(s) or vendor(s) not available!', 'error');
        return
      }
    } catch {
      this._connMessageService.showToastMessage('No department(s)/category(s)/manufacturer(s) or vendor(s) not available!', 'error');
      return
    }

    // Fallback: if editing and no new uploads, carry over existing images
    if (!this._productService.hasGalleryChanged && !this._productService.thImages.length && this._productService.activeItem?.itemPictures?.length) {
      this._productService.thImages = this._productService.activeItem.itemPictures.map((p: any) => p.picture);
      const flagged = this._productService.activeItem.itemPictures.find((p: any) => p.isFeature || p.isDefault)?.picture;
      let flaggedIndex = flagged ? this._productService.thImages.indexOf(flagged) : -1;
      if (flaggedIndex === -1 && this._productService.thImages.length) {
        flaggedIndex = 0;
      }
      if (flaggedIndex >= 0) {
        this._productService.featureImageIndex = flaggedIndex;
        this._productService.featureImage = this._productService.thImages[flaggedIndex];
      }
    }

    if (this._productService.featureImageIndex === null && this._productService.thImages.length) {
      this._productService.featureImageIndex = 0;
      this._productService.featureImage = this._productService.thImages[0];
    }

    // Map existing thumbnails when editing so we preserve server paths
    const thumbMap = new Map<string, string>();
    const pictureIdMap = new Map<string, string>();
    const pictureItemsIdMap = new Map<string, string>();
    if (this._productService.activeItem?.itemPictures?.length) {
      this._productService.activeItem.itemPictures.forEach((p: any) => {
        if (p?.picture) {
          thumbMap.set(p.picture, p.pictureThumbnail || p.picture);
          if (p?.id) {
            pictureIdMap.set(p.picture, p.id);
          }
          if (p?.itemsId || p?.ItemsId) {
            pictureItemsIdMap.set(p.picture, p.itemsId || p.ItemsId);
          }
        }
      });
    }

    let thfiles: any[] = [];
    let featurePicture: string | null = null;
    let featureThumb: string | null = null;
    let chosenFeatureIndex =
      this._productService.featureImageIndex !== null
        ? this._productService.featureImageIndex
        : -1;
    if (this._productService.thImages.length) {
      let x = 1;
      for (let i = 0; i < this._productService.thImages.length; i++) {
        const f = this._productService.thImages[i];
        if (chosenFeatureIndex < 0 && this._productService.featureImage === f) {
          chosenFeatureIndex = i;
        }
        thfiles.push({
          orderNo: x++,
          picture: f,
          pictureThumbnail: thumbMap.get(f) || f,
          id: pictureIdMap.get(f),
          itemsId: pictureItemsIdMap.get(f) || this._productService.activeItem?.id,
          isFeature: false,
          isDefault: false
        });
      }

      // If no explicit feature was found, force the first image as feature/default
      if (chosenFeatureIndex < 0 && thfiles.length) {
        chosenFeatureIndex = 0;
      }

      if (chosenFeatureIndex >= 0 && thfiles[chosenFeatureIndex]) {
        thfiles = thfiles.map((p, idx) => ({
          ...p,
          isFeature: idx === chosenFeatureIndex,
          isDefault: idx === chosenFeatureIndex,
        }));
        this._productService.featureImageIndex = chosenFeatureIndex;
        this._productService.featureImage = thfiles[chosenFeatureIndex].picture;
      }

      const featureEntry = thfiles.find((p) => p.isFeature) || thfiles[chosenFeatureIndex] || thfiles[0];
      featurePicture = featureEntry?.picture || null;
      featureThumb = featureEntry?.pictureThumbnail || featurePicture;
    } else {
      // Explicitly clear feature when nothing is in the gallery
      this._productService.featureImageIndex = null;
      this._productService.featureImage = null;
    }

    let priceA = this._productService.pts.priceA ? this._productService.pts.priceA : 0
    let priceB = this._productService.pts.priceB ? this._productService.pts.priceB : 0
    let priceC = this._productService.pts.priceC ? this._productService.pts.priceC : 0
    let costPrice = this._productService.pts.costPrice ? this._productService.pts.costPrice : 0
    let caseQty = this._productService.pts.caseQty ? this._productService.pts.caseQty : 0
    let discountPrice = this._productService.pts.discountPrice ? this._productService.pts.discountPrice : 0
    let maxLevel = this._productService.pts.maxLevel ? this._productService.pts.maxLevel : 0
    let minLevel = this._productService.pts.minLevel ? this._productService.pts.minLevel : 0
    let reorderLevel = this._productService.pts.reorderLevel ? this._productService.pts.reorderLevel : 0
    let minOrderQty = this._productService.pts.minOrderQty ? this._productService.pts.minOrderQty : 0
    //  Auto PO
    let maxOrderQty = this._productService.pts.maxOrderQty ? +this._productService.pts.maxOrderQty : 0
    let autoPurchaseOrder = this._productService.pts.autoPurchaseOrder ? this._productService.pts.autoPurchaseOrder : false
    // Auto PO   
    let sp = 0
    if (this._productService.selectedDefaultPrice.value === 1) sp = priceA
    else if (this._productService.selectedDefaultPrice.value === 2) sp = priceB
    else if (this._productService.selectedDefaultPrice.value === 3) sp = priceC

    let sellType = ''
    const selectedSellTypeId = this._abd.selectedProductSellType?.id
    this._productService.isSellOnline = selectedSellTypeId === 1 || selectedSellTypeId === 3
    if (selectedSellTypeId == 1) sellType = 'online'
    else if (selectedSellTypeId == 2) sellType = 'offline'
    else if (selectedSellTypeId == 3) sellType = 'all'

    const shippingDimention = {
      weightUOM: this._productService.selectedShippingWeight.id,
      width: this._productService.shippingWidth,
      dimensionUOM: this._productService.selectedShippingDimension.id,
      height: this._productService.shippingHeight,
      weight: this._productService.shippingWeight,
      length: this._productService.shippingLength,
    }

    let os = []
    try {
      if (this._productService.selectedLocations && this._productService.selectedLocations.length > 0) {
        for (let l of this._productService.selectedLocations) {
          let qty = 0
          if (this._productService.isNew) qty = l.openingStock
          else qty = l.stockOnHand

          const model = {
            locationId: l.id,
            skuCode: this._productService.pts.sku,
            quantity: qty,
            price: sp
          }
          os.push(model)
        }
      }
    } catch { }

    os = this.buildOpeningStockChangePayload(os)

    // let meta_data = {
    //   itemSKUId:this._productService.pts.itemSKUId,
    //   id:this._productService.pts.itemSKUId,
    //   barcodes:this.tF.altBarcodes.value,
    //   skus:this.tF.altSKUs.value,
    //   tags:this.tF.altTags.value,
    //  }
    const taxRateValue = this._productService.selectedTaxRate?.value ?? this._productService.taxRates?.[0]?.value ?? null;
    const uomId = this._abd.selectedUom?.id ?? null;
    let skus = []
    const existingSkuId = !this._productService.isNew
      ? (this._productService.activeItem?.ItemSKUs?.[0]?.id
        ?? this._productService.activeItem?.ItemSKUs?.[0]?.Id
        ?? this._productService.activeItem?.crsItemSKUs?.[0]?.id
        ?? this._productService.activeItem?.crsItemSKUs?.[0]?.Id
        ?? this._productService.activeItem?.itemSKUs?.[0]?.id
        ?? this._productService.activeItem?.itemSKUs?.[0]?.Id
        ?? this._productService.pts?.itemSKUId
        ?? null)
      : null
    const skuIdToUse = this._productService.isNew ? '' : (existingSkuId ?? String(this._productService.pts.sku ?? '').trim())
    skus.push({
      id: skuIdToUse,
      skuCode: this._productService.pts.sku,
      barcode: this._productService.pts.barcode,
      //---- 
      // --BST-- 
      barcodes: this.tF.altBarcodes.value,
      skus: this.tF.altSKUs.value,
      tags: this.tF.altTags.value,
      // --BST--

      costPrice: costPrice,
      salePrice: sp,
      salePriceA: priceA,
      salePriceB: priceB,
      salePriceC: priceC,
      grouping: this._productService.selectedGrouping.value,
      taxRateId: taxRateValue,
      sellQuantity: this._productService.selectedSellQuantity.value,
      caseQty: caseQty,
      uomId: uomId,
      openingStock: 0,
      defaultPrice: this._productService.selectedDefaultPrice.value,
      title: this._productService.pts.t_productName, //this.__productDetail?.editform.get('productName').value.trim(),
      taxable: this._productService.isTaxable,
      taxRateValue: taxRateValue,
      defaultPriceValue: this._productService.selectedDefaultPrice.value,
      sellPriceDefaultValue: 0,
      caseQuantityValue: 0,
      unitGramValue: 0,
      discountPrice: discountPrice,
      shippingDimention: shippingDimention,
      maxLevel: maxLevel,
      minLevel: minLevel,
      reorderLevel: reorderLevel,
      minOrderQty: minOrderQty,
      // Auto PO
      maxOrderQty: maxOrderQty,
      autoPurchaseOrder: autoPurchaseOrder,
      // Auto PO
    })

    const createdDate = this._productService.isNew
      ? new Date()
      : this._productService.activeItem?.createdDate || this._productService.activeItem?.createdOn || new Date()
    const lastEdited = new Date()

    const finalImage = this._productService.thImages.length ? featurePicture : null;
    const finalThumb = this._productService.thImages.length ? featureThumb : null;

    const model = {
      "itemName": this._productService.pts.t_productName, //this.__productDetail?.editform.get('productName').value.trim(),
      "notes": this._productService.productNotes.trim(),
      "descriptionURL": this._productService.pts.descriptionUrl,
      "itemType": this._productService.selectedProductType.value,
      "soldAs": this._productService.selectedSellAs.value,
      "ageRestriction": this._productService.selectedAgeRestriction.value,
      "gender": this._productService.selectedGender.value,
      "allowDiscount": this._productService.selectedDiscount.value,
      "isTaxable": this._productService.isTaxable,
      "isOpnDept": this._productService.isOpenPrice,
      "showNotesWhen": this._productService.ShowNotesWhenRingingItem,
      "printOnInvoice": this._productService.printNotesOnReceipt,
      "printAsQRCodeOnReceipt": this._productService.isPrintAsQR,
      "trackStock": this._productService.isTrackStock,
      "isActive": true,
      "createdDate": createdDate,
      "lastEdited": lastEdited,
      "addedBy": this._globals.userInfo.userID,
      "departmentId": this._abd.selectedDepartment.id,
      "categoryId": this._abd.selectedCategory.id,
      "manufacturerId": this._abd.selectedManufacturer.id,
      "vendorId": this._abd.selectedVendor.id,
      "isTrackInventory": this._productService.isTrackStock,
      "allowNegativeStock": this._productService.isAllowNegativeStock,
      "description": this._productService.productDescription,
      "image": finalImage,
      "imageThumbnail": finalThumb,
      "grouping": this._productService.selectedGrouping.value,
      "crsItemSKUs": skus,
      "VariantAttributes": this._productService.variantAttributes,
      "VariantImages": this._productService.variantImages,
      "OpeningStocks": os,
      "ItemPictures": thfiles,
      "DiscountPrice": discountPrice,
      "SellOnline": this._productService.isSellOnline,
      "productSellType": sellType,
      "isReturnable": this._productService.isReturnable,
    }

    let saved = false
    if (this.isNew) {
      try {
        this._abd.showSpinner()
        this._productService.saveProduct(JSON.stringify(model)).subscribe(res => {
          if (res.success) {
            this.saveLabel(model)

            this._connMessageService.showToastMessage('Product saved successfully.', 'success');
            saved = true
            this._abd.hideSpinner()
            if (where2 == 'save-only')
              window.history.back()
          }
        })
      } catch { this._abd.hideSpinner() }
      finally { }
    } else {
      try {
        this._abd.showSpinner()
        this._productService.updateProduct(JSON.stringify(model), this._productService.activeItem.id).subscribe(res => {
          if (res.success) {
            this.saveLabel(model)
            this._productService.selectedLocations = []
            let loc = this._abd.locations
            for (let i = 0; i < loc.length; i++) {
              try {
                delete loc[i].newQoh
              }
              catch { }
            }

            this._connMessageService.showToastMessage('Product updated successfully.', 'success');
            saved = true
            if (where2 == 'save-only') {
              window.history.back()
            }
            this._abd.hideSpinner()
          }
        })
      } catch { this._abd.hideSpinner() }
      finally {

      }
    }
  }
  // goToRoute() {
  //   let p = null;

  //   this._route.queryParams.subscribe(params => {
  //     p = params['p']; 
  //   });
  //   if(p !== undefined){
  //     if(p.includes('list')){
  //      this._router.navigate([""])
  //     }
  //   }
  // }
  //  Label Printing
  saveLabel(value?: any) {
    if (this.labelForm.valid && this.f.locations.value.length > 0 && this.f.noOfCopy.value !== "") {
      this._abd.showSpinner()
      let objList = this.f.locations.value.map((loc) => {

        let locId = this.f.location.value.locationId
        let location = this._abd.locations.filter((val) => val.locationId === locId)[0]
        let address = location.locationName + ", " + location.address + "," + location.city + ", " + location.state + ", " + location.zip


        return {
          printerBrand: this.selectedBrand.brand,
          printerModel: this.selectedBrand.model,
          labelSize: this.selectedlabelSizes.name,
          barcodeStyle: this.selectedlabelStyle.name,
          ProductName: value.itemName,
          Barcode: value.crsItemSKUs[0].barcode,
          Sku: value.crsItemSKUs[0].skuCode,
          Location: loc.id,
          Business: this._globals.userInfo?.businessSetup[0].businessName,
          Price: value.crsItemSKUs[0].salePrice,
          LocationName: address,
          LocationId: this.f.location.value.id,
          NoOfCopy: +this.f.noOfCopy.value,
          TemplateId: 0,
          iscustom: 1,
          BrandImage: this._productService.labelPrintingImage,
          Status: '0',
        }
      })
      this._barcodeLabelServices.saveBarcodeLabel(objList).subscribe(res => {
        if (res.success) {
          this._abd.hideSpinner();
          this._connMessageService.showToastMessage('Product Label Printing saved successfully', 'success');
        }
        else {
          this._connMessageService.showToastMessage(`Product Label Printing could not be saved.`, 'error');
          this._abd.hideSpinner()
        }
      }, (error) => {
        this._abd.hideSpinner()
      })
    }
  }

  // /Label Printing
  async makeThFiles_1() {
    this.thFiles = []
    let files = []
    const self = this


    if (!this.fileInput) return
    if (!this.fileInput.files) return

    for (let file of this.fileInput.files) {
      var fileToLoad = file;
      var fileReader = new FileReader();

      fileReader.onload = function (fileLoadedEvent) {
        var srcData = fileLoadedEvent.target.result; // <--- data: base64

        var newImage = document.createElement('img');
        newImage.src = <any>srcData;

        // document.getElementById("imgTest").innerHTML = newImage.outerHTML;

        self.thFiles.push(srcData)
        //alert("Converted Base64 version is " + document.getElementById("imgTest").innerHTML);
        // //console.log("Converted Base64 version is " + document.getElementById("imgTest").innerHTML);
      }
      fileReader.readAsDataURL(fileToLoad);
    }
  }

  validToSave() {
    try {
      if (this.__productDetail)
        this._productService.validate.pd = this.__productDetail?.isFormValid()
      if (this.__productPricing)
        this._productService.validate.pp = this.__productPricing?.isFormValid()
      if (this.__productInventory)
        this._productService.validate.pi = this.__productInventory?.isFormValid()
    } catch { }
    //console.log('valid-DD', this._productService.validate.pp)

    return (
      this._productService.validate.pd &&
      this._productService.validate.pp &&
      this._productService.validate.pi
      && this.tagsForm.valid
    )
  }

  cancelClick() {
    this._abd.selectedProductSellTypeFilter = this._productService.filter.selectedProductSellTypeFilter
    this._abd.selectedLocation = this._productService.filter.selectedLocation
    this._abd.selectedDepartment = this._productService.filter.selectedDepartment
    this._abd.selectedCategory = this._productService.filter.selectedCategory
    this._abd.selectedVendor = this._productService.filter.selectedVendor
    this._abd.selectedManufacturer = this._productService.filter.selectedManufacturer

    this._productService.isNewVendor = false
    this._router.navigate(['app/products'])
  }




}
